import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as o } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as t } from "../../core/accessorSupport/decorators/subclass.js";
import { serviceTileInfoProperty as i } from "../support/serviceTileInfoProperty.js";
import { TilemapCache as p } from "../support/TilemapCache.js";
import a from "../../geometry/SpatialReference.js";

var s = function s(_s2) {
  var l = /*#__PURE__*/function (_s) {
    _inherits(l, _s);

    var _super = _createSuper(l);

    function l() {
      var _this;

      _classCallCheck(this, l);

      _this = _super.apply(this, arguments), _this.copyright = null, _this.minScale = 0, _this.maxScale = 0, _this.spatialReference = null, _this.tileInfo = null, _this.tilemapCache = null;
      return _this;
    }

    _createClass(l, [{
      key: "readMinScale",
      value: function readMinScale(e, r) {
        return null != r.minLOD && null != r.maxLOD ? e : 0;
      }
    }, {
      key: "readMaxScale",
      value: function readMaxScale(e, r) {
        return null != r.minLOD && null != r.maxLOD ? e : 0;
      }
    }, {
      key: "supportsBlankTile",
      get: function get() {
        return this.version >= 10.2;
      }
    }, {
      key: "readTilemapCache",
      value: function readTilemapCache(e, r) {
        return r.capabilities && r.capabilities.indexOf("Tilemap") > -1 ? new p({
          layer: this
        }) : null;
      }
    }]);

    return l;
  }(_s2);

  return e([r({
    json: {
      read: {
        source: "copyrightText"
      }
    }
  })], l.prototype, "copyright", void 0), e([r()], l.prototype, "minScale", void 0), e([o("service", "minScale")], l.prototype, "readMinScale", null), e([r()], l.prototype, "maxScale", void 0), e([o("service", "maxScale")], l.prototype, "readMaxScale", null), e([r({
    type: a
  })], l.prototype, "spatialReference", void 0), e([r({
    readOnly: !0
  })], l.prototype, "supportsBlankTile", null), e([r(i)], l.prototype, "tileInfo", void 0), e([r()], l.prototype, "tilemapCache", void 0), e([o("service", "tilemapCache", ["capabilities"])], l.prototype, "readTilemapCache", null), e([r()], l.prototype, "version", void 0), l = e([t("esri.layers.mixins.ArcGISCachedService")], l), l;
};

export { s as ArcGISCachedService };